const FALLBACK_RELAY = "https://bookforge-relay.forgesuiteui.app";

/** House ChatForge box (AccessHub HF_CHAT_ENDPOINT). Origin proxies; never huggingface.cloud. */
export const HOUSE_CHAT_HF_NAME = "qwen3-6-40b-claude-4-6-opus--gji";
export const HOUSE_CHAT_ENDPOINT =
  "https://ud4g6k6v39xj2560.us-east-1.aws.endpoints.huggingface.cloud";

export function isForgeEndpointChatUrl(url: string): boolean {
  return /\/api\/endpoints\/[^/?#]+/i.test(url || "");
}

export function ggufBlockedWithoutEndpoint(
  model: string,
  baseUrl: string,
  source?: string,
): boolean {
  if (source === "endpoint" || isForgeEndpointChatUrl(baseUrl)) return false;
  const blob = (model || "").toLowerCase();
  const gguf = /\.gguf\b/.test(blob) || /\bgguf\b/.test(blob);
  return gguf;
}

export function isHfInferenceEndpointUrl(url: string): boolean {
  return /endpoints\.huggingface\.cloud/i.test(url || "");
}

function looksHfEndpointName(s: string): boolean {
  const t = (s || "").trim();
  return t.length > 0 && t.length <= 64 && /^[a-z0-9][a-z0-9-]*$/i.test(t);
}

export function forgeEndpointIdFromConn(opts: {
  sourceId?: string | null;
  connectionId?: string | null;
  endpointUrl?: string | null;
}): string | null {
  const src = (opts.sourceId || "").trim();
  if (src.startsWith("ep_")) return src.split(":")[0];
  const blob = `${opts.connectionId || ""} ${src}`;
  const ep = blob.match(/ep_[A-Za-z0-9]+/);
  if (ep) return ep[0];
  if (looksHfEndpointName(src)) return src;
  const url = (opts.endpointUrl || "").trim();
  if (isHfInferenceEndpointUrl(url)) {
    try {
      const host = new URL(url.startsWith("http") ? url : `https://${url}`).hostname;
      const first = host.split(".")[0];
      if (first) return first;
    } catch {
      /* keep */
    }
  }
  return null;
}

function trimOpenAiBase(raw: string): string {
  let base = (raw || "").trim().replace(/\/+$/, "");
  if (!base) return base;
  return base
    .replace(/\/chat\/completions$/i, "")
    .replace(/\/completions$/i, "")
    .replace(/\/models$/i, "")
    .replace(/\/+$/, "");
}

export function forgeEndpointChatBase(opts: {
  endpointUrl?: string | null;
  sourceId?: string | null;
  connectionId?: string | null;
  forgeApiUrl?: string;
}): string | null {
  const fromUrl = trimOpenAiBase(opts.endpointUrl || "");
  const forge = (opts.forgeApiUrl || FALLBACK_RELAY).replace(/\/$/, "");
  const id = forgeEndpointIdFromConn(opts);
  if (isHfInferenceEndpointUrl(fromUrl) || (id && looksHfEndpointName(id) && !id.startsWith("ep_"))) {
    const pathId = id || HOUSE_CHAT_HF_NAME;
    return `${forge}/api/endpoints/${pathId}/v1`;
  }
  if (isForgeEndpointChatUrl(fromUrl)) {
    return /\/v1$/i.test(fromUrl) ? fromUrl : `${fromUrl}/v1`;
  }
  if (!id) return null;
  return `${forge}/api/endpoints/${id}/v1`;
}

export function suiteRelayChatBase(forgeApiUrl?: string): string {
  const forge = (forgeApiUrl || FALLBACK_RELAY).replace(/\/$/, "");
  return `${forge}/v1`;
}

export function normalizeOpenAiBaseUrl(raw: string): string {
  let base = (raw || "").trim().replace(/\/+$/, "");
  if (!base) return base;
  base = base
    .replace(/\/chat\/completions$/i, "")
    .replace(/\/completions$/i, "")
    .replace(/\/models$/i, "")
    .replace(/\/+$/, "");
  const needsV1 =
    /endpoints\.huggingface\.cloud$/i.test(base) ||
    /router\.huggingface\.co$/i.test(base) ||
    /api\.openai\.com$/i.test(base) ||
    /api\.x\.ai$/i.test(base) ||
    /bookforge-relay/i.test(base);
  if (needsV1 && !/\/v1$/i.test(base)) {
    base = `${base}/v1`;
  }
  return base;
}
